<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Tiểu mục công việc</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          @click="$router.push('/work-subsection-afs-add')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.code"
              class="form-control f12 hc-37"
              placeholder="Mã tiểu mục"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.name"
              class="form-control f12 hc-37"
              placeholder="Tên tiểu mục"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.isActive"
              :options="optionStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group">
            <!-- <input type="text" v-model.trim="search.taskCode" class="form-control f12 hc-37" placeholder="Danh mục" /> -->
            <Select2
              v-model="search.taskCode"
              :settings="searchCat"
              placeholder="Danh mục"
            ></Select2>
          </div>

          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng tiểu mục công việc</b>: {{ pagination.total }}</span>
            <b-table
              :busy.sync="loading"
              sticky-header
              responsive
              hover
              :items="dataTable"
              :fields="filterTable"
              selectable
              select-mode="single"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(isActive)="data">
                <b-badge
                  class="font-size-12"
                  pill
                  :variant="data.item.isActive ? 'success' : 'danger'"
                  size="sm"
                >
                  {{ data.item.isActive ? 'Đang áp dụng' : 'Đã khóa' }}
                </b-badge>
              </template>
              <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item
                    :href="`/work-subsection-afs/${data.item.id}`"
                    target="_blank"
                    @click="detail(data.item.id)"
                    >Chi tiết</b-dropdown-item
                  >
                  <b-dropdown-item @click="toggleLockStatus(data.item)">
                    {{ data.item.isActive ? 'Khóa' : 'Mở khóa' }}
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.size"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>
    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <!-- Modal xác nhận khóa/mở khóa -->
    <b-modal id="modal-confirm-lock" v-model="confirmLockModal">
      <template #modal-header="{ close }">
        <h5>Xác nhận</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <i class="bx bx-question-mark-circle" style="font-size: 48px; color: #ffc107"></i>
        <p class="py-1" style="font-size: 16px">{{ confirmMessage }}</p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()"> Hủy </b-button>
        <b-button
          :variant="selectedItem?.isActive ? 'danger' : 'success'"
          @click="confirmToggleLock"
        >
          {{ selectedItem?.isActive ? 'Khóa' : 'Mở khóa' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'

  // Cập nhật fieldsTable theo dữ liệu mới
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'code', label: 'Mã tiểu mục' },
    { key: 'name', label: 'Tên tiểu mục' },
    { key: 'isActive', label: 'Trạng thái' },
    { key: 'taskName', label: 'Danh mục' },
    { key: 'groupName', label: 'Nhóm' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  export default {
    data() {
      return {
        Config,
        search: {
          page: 1,
          limit: 20,
        },
        pagination: {
          total: 0,
        },
        dataTable: [],
        fieldsTable,
        filterTable: fieldsTable,
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        loading: false,
        showLoading: false,
        optionStatus: [
          { id: '', text: 'Tất cả' },
          { id: true, text: 'Đang áp dụng' },
          { id: false, text: 'Đã khóa' },
        ],
        lockModal: false,
        stateGr: {},
        searchCat: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                CalendarAfsService.catCalendar({
                  taskName: keySearch,
                  page: 1,
                  size: 20,
                }) // AI
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id: item.taskCode || '',
                            text: item.taskName || '',
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        confirmLockModal: false,
        selectedItem: null,
        confirmMessage: '',
      }
    },
    created() {
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    methods: {
      toggleLockStatus(item) {
        this.selectedItem = item
        this.confirmMessage = item.isActive
          ? `Bạn có chắc chắn muốn khóa tiểu mục "${item.name}"?`
          : `Bạn có chắc chắn muốn mở khóa tiểu mục "${item.name}"?`
        this.confirmLockModal = true
      },
      async confirmToggleLock() {
        try {
          this.showLoading = true
          const newStatus = !this.selectedItem.isActive

          // Gọi API để cập nhật trạng thái
          const response = await CalendarAfsService.updateWorkSubsectionStatus({
            id: this.selectedItem.id,
          })

          if (response.code === 1000) {
            // Cập nhật trạng thái trong bảng
            this.selectedItem.isActive = newStatus

            // Hiển thị thông báo thành công
            this.showNotification(
              'success',
              `${newStatus ? 'Mở khóa' : 'Khóa'} tiểu mục thành công!`
            )
          } else {
            this.showNotification('error', 'Có lỗi xảy ra, vui lòng thử lại!')
          }
        } catch (error) {
          console.error(error)
          this.showNotification('error', 'Có lỗi xảy ra, vui lòng thử lại!')
        } finally {
          this.showLoading = false
          this.confirmLockModal = false
          this.selectedItem = null
        }
      },
      showNotification(type, message) {
        this.iconNoti =
          type === 'success'
            ? require('@/assets/img/noti-success2.svg')
            : require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
        this.notiModal = true
      },
      async fetchData() {
        try {
          this.loading = true
          const data = await CalendarAfsService.getWorkSubsection(this.search)
          if (data.code === 1000) {
            this.dataTable = data.data || []
            this.pagination.total = data.totalPage || 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        await this.fetchData()
      },
      getIndex(index) {
        return (this.search.page - 1) * this.search.limit + index + 1
      },
    },
  }
</script>
